// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IHsaOverviewResponseDto
 */
export interface IHsaOverviewResponseDto {
    /**
     * 
     * @type {number}
     * @memberof IHsaOverviewResponseDto
     */
    active_enrollments?: number;
    /**
     * 
     * @type {number}
     * @memberof IHsaOverviewResponseDto
     */
    total_elections?: number;
    /**
     * 
     * @type {number}
     * @memberof IHsaOverviewResponseDto
     */
    unenrolled_hsas?: number;
    /**
     * 
     * @type {number}
     * @memberof IHsaOverviewResponseDto
     */
    investment_balance?: number;
    /**
     * 
     * @type {number}
     * @memberof IHsaOverviewResponseDto
     */
    investment_participants?: number;
    /**
     * 
     * @type {number}
     * @memberof IHsaOverviewResponseDto
     */
    plan_year_contributions?: number;
}

/**
 * Check if a given object implements the IHsaOverviewResponseDto interface.
 */
export function instanceOfIHsaOverviewResponseDto(value: object): value is IHsaOverviewResponseDto {
    return true;
}

export function IHsaOverviewResponseDtoFromJSON(json: any): IHsaOverviewResponseDto {
    return IHsaOverviewResponseDtoFromJSONTyped(json, false);
}

export function IHsaOverviewResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IHsaOverviewResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'active_enrollments': json['active_enrollments'] == null ? undefined : json['active_enrollments'],
        'total_elections': json['total_elections'] == null ? undefined : json['total_elections'],
        'unenrolled_hsas': json['unenrolled_hsas'] == null ? undefined : json['unenrolled_hsas'],
        'investment_balance': json['investment_balance'] == null ? undefined : json['investment_balance'],
        'investment_participants': json['investment_participants'] == null ? undefined : json['investment_participants'],
        'plan_year_contributions': json['plan_year_contributions'] == null ? undefined : json['plan_year_contributions'],
    };
}

export function IHsaOverviewResponseDtoToJSON(json: any): IHsaOverviewResponseDto {
    return IHsaOverviewResponseDtoToJSONTyped(json, false);
}

export function IHsaOverviewResponseDtoToJSONTyped(value?: IHsaOverviewResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'active_enrollments': value['active_enrollments'],
        'total_elections': value['total_elections'],
        'unenrolled_hsas': value['unenrolled_hsas'],
        'investment_balance': value['investment_balance'],
        'investment_participants': value['investment_participants'],
        'plan_year_contributions': value['plan_year_contributions'],
    };
}

